import ArticleSection from './ArticleSection';

export { default as ArticleSectionTheme } from './ArticleSection.style';
export default ArticleSection;
